import {make} from "vuex-pathify";
import {AuthService} from "@/services";
import router from "@/router";
import store from "@/store";
import jwtDecode from "jwt-decode";
import $http from "@/plugins/axios";
import $const from "@/common/const";

const state = {
    token: localStorage.getItem('token') || ''
}
const mutations = {
    ...make.mutations(state)
}

const actions = {
    ...make.actions(state),
    signIn() {
        const provider = localStorage.getItem($const.LOCAL_STORAGE_KEY.PROVIDER)
        AuthService.signIn(JSON.parse(provider))
    },
    signOut() {
        const provider = localStorage.getItem($const.LOCAL_STORAGE_KEY.PROVIDER)
        localStorage.clear()
        AuthService.signOut(JSON.parse(provider))
    },
    getToken({dispatch}) {
        const authCode = router.currentRoute.query.code
        const provider = localStorage.getItem($const.LOCAL_STORAGE_KEY.PROVIDER)
        AuthService.getToken(JSON.parse(provider), authCode)
            .then(res => {
                const accessToken = res.data['accessToken'];
                store.set('user/profile', jwtDecode(accessToken))
                localStorage.setItem('token', accessToken);
                dispatch('setToken', accessToken);
                $http.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
                router.replace('/')
            })
    },
}

const getters = {
    isLoggedIn: state => !!state.token,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
